import { createAction } from '@ngrx/store';

export const enter = createAction('[App Init Factory] Enter');
